import Enum from './Enum.js';

export default class CampaignType extends Enum {
    static get entries() {
        return {
            event: 'event',
            mailing: 'mailing',
            sms: 'sms',
        };
    }

    static get EVENT() {
        return this.entries.event;
    }

    static get MAILING() {
        return this.entries.mailing;
    }

    static get SMS() {
        return this.entries.sms;
    }

    static get translationGroup() {
        return 'campaignType';
    }
}
